// SALES-032: pure logic for the leads page primary action + status pill tone.
// Kept React-free so it can be unit-tested directly.

// StatusPill's own map paints new/contacted/quoted all blue — pass tone explicitly.
export const LEAD_STATUS_TONE = { new: "blue", contacted: "green", quoted: "gold", won: "green", lost: "red" };

// The single primary action an ALL-LEADS row/card shows. Mirrors the pre-SALES-032
// conditions exactly: Contacted ✓ on status==="new" || no salesperson (including a
// lost/won lead with no salesperson); else Open booking once it has one; else
// Convert on contacted/quoted; else none (a lost lead with a salesperson).
export function leadPrimaryKind(lead) {
  const status = (lead.status || "new").toLowerCase();
  if (status === "new" || !lead.salesperson) return "contacted";
  if (lead.converted_booking_id) return "open-booking";
  if (status === "contacted" || status === "quoted") return "convert";
  return "none";
}

// Website leads never showed Contacted ✓ (invariant 3): a converted one opens its
// booking, otherwise Convert is the primary — exactly as before.
export function websitePrimaryKind(lead) {
  if (lead.converted_booking_id) return "open-booking";
  return "convert";
}

// Convert belongs in the ⋯ menu when it is available today (status !== "won" and
// not already converted) and it is NOT already the primary action.
export function showConvertInMenu(lead, primaryKind) {
  const status = (lead.status || "new").toLowerCase();
  return status !== "won" && primaryKind !== "convert" && !lead.converted_booking_id;
}
